import { Box } from "@mui/material";
import type { WorkbookFilter } from "../../../../../../api/types/workbookRuns.types";
import WorkbookFilterItemDateInput from "./WorkbookFilterItemDateInput";
import WorkbookFilterItemLabel from "./WorkbookFilterItemLabel";

interface Props {
  filter: WorkbookFilter;
  onUpdateFilterValue: (filterValue: string, isValid: boolean) => void;
}
const WorkbookFilterItemDate = ({ filter, onUpdateFilterValue }: Props) => {
  return (
    <>
      <WorkbookFilterItemLabel filter={filter} showCompanyLogo={false} />
      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        <WorkbookFilterItemDateInput filterValue={filter.value[0] ?? ""} onUpdateFilter={onUpdateFilterValue} />
      </Box>
    </>
  );
};

export default WorkbookFilterItemDate;
